module.exports = "/_next/static/images/pizza_apperance-1363c8bcef4009527d16be6c4e1fee25.jpg";